<template>
  <div class="page">
    <div class="page-container container-buyer-requirements">
      <h2>Expense Breakdown</h2>

      <div class="page-data-grid data-grid-table top-emphasis">

        <div class="page-data-item nested no-line">
          <img src="../buyer-listing-details/full-details-content/assets/register.svg" />
          <div>
            <label>Total Overhead:</label>
            <span>{{ listing.expenses_total_overhead || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested no-line">
          <div>
            <label>% of Revenue:</label>
            <span>{{ listing.expenses_percent_of_revenue || '0' }}%</span>
          </div>
        </div>

      </div>
      <div class="page-data-grid data-grid-table">


        <div class="page-data-item nested no-line top-line">
          <div class="page-svg-wrapper">
            <div>
              <InfoGridDecorativeLinesPage4 />
            </div>
          </div>
          <div>
            <label>Employee Compensation - Licensed:</label>
            <span>{{ listing.expenses_employee_compensation_licensed || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested no-line top-line">
          <img src="../buyer-listing-details/full-details-content/assets/person-star.svg" />
          <div>
            <label>Employee Benefits:</label>
            <span>{{ listing.expenses_employee_benefits || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested no-line">
          <img src="../buyer-listing-details/full-details-content/assets/employees.svg" />
          <div>
            <label>Employee Compensation - Admin:</label>
            <span>{{ listing.expenses_employee_compensation_admin || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested no-line">
          <img src="../buyer-listing-details/full-details-content/assets/moneybag.svg" />
          <div>
            <label>Employee Only Payroll Taxes:</label>
            <span>{{ listing.expenses_employee_only_payroll_taxes || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <div class="page-svg-wrapper">
            <div>
              <InfoGridDecorativeLinesPage4 class="flip-vertical" />
            </div>
          </div>
          <div>
            <label>1099 Contracter Compensation:</label>
            <span>{{ listing.expenses_contractor_compensation || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <div></div>
        </div>


        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/announce.svg" />
          <div>
            <label>Advertising & Marketing:</label>
            <span>{{ listing.expenses_advertising || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/building.svg" />
          <div>
            <label>Annual Lease / Rent: (see below)</label>
            <span>{{ listing.expenses_annual_lease_rent || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/book-open.svg" />
          <div>
            <label>Dues / Subscriptions</label>
            <span>{{ listing.expenses_dues || '0' | currency }}</span>
          </div>
        </div>

        <div class="page-data-item nested">
          <img src="../buyer-listing-details/full-details-content/assets/brain-work.svg" />
          <div>
            <label>Continuing Education:</label>
            <span>{{ listing.expenses_continuing_education || '0' | currency }}</span>
          </div>
        </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/lock.svg" />
            <div>
              <label>Insurance</label>
              <span>{{ listing.expenses_insurance || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/certificate.svg" />
            <div>
              <label>Licensing Cost:</label>
              <span>{{ listing.expenses_licensing_cost || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/basketball.svg" />
            <div>
              <label>Meals & Entertainment:</label>
              <span>{{ listing.expenses_entertainment || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/paperclip.svg" />
            <div>
              <label>Office Supplies:</label>
              <span>{{ listing.expenses_office_supplies || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/dots.svg" />
            <div>
              <label>Other Expenses:</label>
              <span>{{ listing.expenses_other || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/diploma.svg" />
            <div>
              <label>Professional Services:</label>
              <span>{{ listing.expenses_professional_services || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/cycle.svg" />
            <div>
              <label>Referral Fees:</label>
              <span>{{ listing.expenses_referral_fees || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/hammer.svg" />
            <div>
              <label>Repairs & Maintenance:</label>
              <span>{{ listing.expenses_maintenance || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/gears.svg" />
            <div>
              <label>Software Costs:</label>
              <span>{{ listing.expenses_software_costs || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested">
            <img src="../buyer-listing-details/full-details-content/assets/airplane.svg" />
            <div>
              <label>Travel: Normalized</label>
              <span>{{ listing.expenses_travel || '0' | currency }}</span>
            </div>
          </div>

          <div class="page-data-item nested no-line">
            <img src="../buyer-listing-details/full-details-content/assets/antenna.svg" />
            <div>
              <label>Utilities:</label>
              <span>{{ listing.expenses_utilities || '0' | currency }}</span>
            </div>
          </div>

          <div class="data-card">
            <div >
              <div class="bottom-right-card">
                <label>Other Notes Regarding Expenses</label><br>
                <div v-html="listing.expenses_notes || 'N/A'"></div>
              </div>
            </div>
          </div>


      </div>
    </div>


    <BottomColorBar />
  </div>
</template>

<script>
import BottomColorBar from './partials/BottomColorBar'
import InfoGridDecorativeLinesPage4 from './partials/InfoGridDecorativeLinesPage4'

export default {
  name: 'PdfPage4',
  components: {
    BottomColorBar,
    InfoGridDecorativeLinesPage4
  },
  props: {
    listing: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({

  }),

  computed: {
    log () {
      console.log(this.listing);
      return 'returned from log'
    },
    //
    // technologiesInUse () {
    //   return this.technologies
    //     .filter(({ variable }) => this.listing[variable])
    // },
  },
}
</script>

<style scoped>
.page-grid {
  width: 100%;
  height: 100%;
  padding: 30px 10px;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.page-container {
  position: relative;
  padding: 10px 20px;
  border: 2px solid transparent;
}

.page-container.container-technology-use .page-data-grid {
  grid-row-gap: 7px;
}

.page-container:nth-child(1)::after {
  content: '';
  position: absolute;
  top: 10px;
  right: -1px;
  bottom: 10px;
  width: 2px;
  background-color: #F2F2F2;
}

.page-container:nth-child(3)::after,
.page-container:nth-child(4)::after {
  content: '';
  position: absolute;
  top: 0;
  left: 10px;
  right: 10px;
  height: 2px;
  background-color: #F2F2F2;
}

.page-graph-demographics {
  width: 350px;
}

h2 {
  margin-top: 40px;
  margin-bottom: 40px;
}

h3 {
  margin: 30px 0 0;
}

.page .data-grid-table {
  justify-content: flex-start;
  grid-auto-flow: row;
  grid-auto-rows: 60px;
}

.page .data-grid-table .page-data-item {
  border-bottom: 2px solid #F2F2F2 ;
}

.no-line {
  border-bottom: 0px solid rgba(0,0,0,0) !important;
}

.top-line {
  border-top: 2px solid #F2F2F2 !important;
}

.page-data-item.nested {
  grid-template-columns: 40px 1fr;
  grid-column-gap: 10px;
  align-items: center;
}

.container-comm-methods,
.container-meeting-freq {
  padding-top: 40px;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
}

.meeting-frequency-wrapper {
  grid-row-start: 1;
  grid-row-end: 3;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  padding: 13px 28px 28px;
  background-color: #97C13133;
}

.meeting-frequency-wrapper h2 {
  margin-bottom: 0;
}

.page-data-card-box {
  width: 250px;

  justify-content: center;
}

.page-data-card-box span {
  flex-grow: 0;
}

.page-graph-meetings {
  position: relative;
  height: 250px;
  width: 270px;
}

.meeting-frequency-labels {
  width: 100%;
  margin-top: -10px;
  margin-bottom: 10px;
  padding-left: 30px;

  display: grid;
  grid-row-gap: 5px;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
}

.meeting-frequency-labels .page-data-item.nested {
  grid-template-columns: 20px 35px 1fr;
}

.page-svg-wrapper {
  position: relative;
  height: 34px;
  width: 34px;
}

.flip-vertical {
  transform: rotate(180deg);
  transform: scaleY(-1);
}

.top-emphasis label {
  font-size: 1.75em !important;
  margin-bottom: 10px;
}

.top-emphasis span {
  font-size: 1.25em !important;
}

.top-emphasis {
  height: 100px;
  margin-top: 20px;
}

.bottom-right-card {
  color: #5F6062;
  padding: 8px !important;
  margin: 0;
  border: 3px dashed #99CC33;
}

.bottom-right-card label {
  font-size: 12pt;
  line-height: 14pt;
  font-family: "SansationBold", sans-serif;
  color: #5F6062;
  /* margin-top: 5px; */
  padding: 8px 0 !important;
  /* margin-left: 5px; */
}

.bottom-right-card span {
  margin-left: 5px;
  font-size: 12pt;
  line-height: 14pt;
  font-family: "Sansation", sans-serif;
  color: #5F6062;
}

.data-card {
  margin-top: 10px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage4.vue